import GameModel from "../../../vendor_core/core/src/model/GameModel";
import VendorSpinResultState from "../../../vendor_core/src/states/VendorSpinResultState";
import KeyboardManager, { Key } from "../../../vendor_core/core/src/utils/KeyboardManager";
``
export default class TRWCascadeSpinResultState extends VendorSpinResultState {
    protected init(): void {
        super.init();
    }

    /**
     * Here, exit needs to be called only for cascade games
     */
    protected setSkipWithSpace(): void {
        if (GameModel.spaceToSpin) {
            KeyboardManager.onKey("pressed", Key.SPACE, this.skipWithKey, this);
        }

        this.exit();
    }

    /**
     * This need to be empty for cascade game
     * @param delay 0
     */
    protected stopReels(delay = 0): void {
        return;
    }
}
